// extracted by mini-css-extract-plugin
export default {"container":"supportTicketsSection_container__MB7tA","linksWrapper":"supportTicketsSection_linksWrapper__IeIui","linkWrapper":"supportTicketsSection_linkWrapper__GQ0gw"};